export * from './Input';

import Input from './Input';
export default Input;
